// ConvertToCanon/artstyles/ClassicismStyle.js
export const applyClassicismStyle = async (canvas, ctx, setMessage, language) => {
  // 고전주의: 균형과 조화
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;
  
  // 균형잡힌 색상과 부드러운 그라데이션
  for (let i = 0; i < data.length; i += 4) {
    const avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
    data[i] = avg + (data[i] - avg) * 0.8;
    data[i + 1] = avg + (data[i + 1] - avg) * 0.8;
    data[i + 2] = avg + (data[i + 2] - avg) * 0.8;
  }
  
  ctx.putImageData(imageData, 0, 0);
};